"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Pin: function() {
        return Pin;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Pin = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        d: "M15.8161 2L7.64897 2C7.43353 2 7.23962 2.08784 7.09875 2.2287C6.95789 2.36957 6.87005 2.56348 6.87005 2.77892L6.87171 8.12034C6.64632 8.29933 6.43253 8.49323 6.22868 8.69707C5.01555 9.9102 4.20183 11.5227 4.00461 13.3176C3.99273 13.4263 4.00388 13.5364 4.03735 13.6405C4.07083 13.7446 4.12586 13.8406 4.19888 13.922C4.2719 14.0035 4.36125 14.0687 4.46113 14.1133C4.56101 14.1579 4.66917 14.181 4.77856 14.181L10.8011 14.181L10.7978 21.3173C10.7975 21.4045 10.8281 21.489 10.884 21.5559L11.4441 22.2288C11.585 22.3995 11.8419 22.4078 11.996 22.2536C12.0043 22.2453 12.0126 22.2371 12.0192 22.2271L12.5794 21.5543C12.6357 21.488 12.6656 21.4018 12.6656 21.3156V14.176L18.6881 14.176C18.9036 14.176 19.0975 14.0882 19.2383 13.9473C19.3991 13.7866 19.4886 13.5579 19.4621 13.3126C19.2301 11.2145 18.1595 9.36827 16.5917 8.11537V2.77561C16.5933 2.34969 16.2453 2.00166 15.8161 2ZM14.9062 8.93241L15.5393 9.43954C16.5198 10.2226 17.2346 11.2893 17.586 12.4939L5.879 12.4906C5.97512 12.1591 6.09776 11.8376 6.25023 11.5261C6.54522 10.9195 6.93966 10.3693 7.42027 9.88866C7.57937 9.72956 7.74841 9.57709 7.92574 9.43622L8.55882 8.92909V3.68546L14.9062 3.68546V8.93241Z",
        fill: "currentColor"
    })
}), "Pin");
const _default = Pin;
